<template>
  <section
    class="test bg-white h-40 lg:w-1/4 w-11/12 flex flex-row space-x-4 rounded-md border-t-2 border-solid border-pink-600 p-4"
  >
    <div class="flex w-6 justify-center items-center text-2xl text-pink-700 flex-shrink-0">
      <slot name="icon"></slot>
    </div>
    <div class="flex flex-1 justify-start items-start flex-col overflow-hidden">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Info-card-component',
});
</script>
